export const CONFIGURACION_AUTOMATIZACIONES_MODULE_ID = 'configuracion_automatizaciones'

export const ROLES_DEFAULT_CONFIGURACION_AUTOMATIZACIONES = [
  'ADMIN',
  'COLABORADOR',
  'SUPER_COLABORADOR',
]

export function defaultConfiguracionAutomatizacionesAccess(roles) {
  return (roles || []).some((r) =>
    ROLES_DEFAULT_CONFIGURACION_AUTOMATIZACIONES.includes(r),
  )
}
